import React from 'react'
import styled from '@emotion/styled'
import Ajanlatkeres from '../containers/Ajanlatkeres'

const Main = styled.main`
  margin-top: 70px;
  line-height: 1.5rem;
`

const Title = styled.h2`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2.5rem;
  }
`

const SubTitle = styled.h3`
  padding-top: 90px;
  margin-top: -80px;
  font-weight: 200;
  color: #275236;

  @media (min-width: 64em) {
    font-size: 2rem;
  }
`

const Section = styled.section`
  position: relative;
  padding: 0 1rem;
  padding-bottom: 8px;
  margin: 2rem 0;

  a {
    text-decoration: none;
    color: initial;
  }

  ul {
    list-style: circle;

    li {
      margin: 0.5rem 0;

      a:after {
        content: ' ›';
      }
    }
  }

  &:first-of-type {
    margin-bottom: 4rem;
  }

  &:nth-of-type(2n) {
    background: linear-gradient(transparent 80px, rgba(39, 82, 54, 0.2) 80px, rgba(39, 82, 54, 0.2) 100%);

    ${SubTitle} {
      // color: #fff;
    }

    &:before {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      top: calc(80px - 2rem);
      width: 100%;
      height: 2rem;
      background: linear-gradient(to right top, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }

    &:after {
      display: block;
      content: '';
      left: 0;
      position: absolute;
      bottom: -2rem;
      width: 100%;
      height: 2rem;
      background: linear-gradient(to left bottom, rgba(39, 82, 54, 0.2) 49.5%, transparent 50%);
    }
  }

  @media (min-width: 64em) {
    p,
    ul,

    ${Title}, ${SubTitle} {
      margin: 2rem auto;
      max-width: 960px;
    }

    &:nth-of-type(2n) {
      &:before {
        top: calc(80px - 4rem);
        height: 4rem;
      }

      &:after {
        bottom: -4rem;
        height: 4rem;
      }
    }
  }
`

const Images = styled.section`
  overflow-y: hidden;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  height: 320px;
  margin: 0 -1rem;
  width: calc(100% + 2rem);
  display: flex;
  flex-direction: row;

  img {
    flex: 1;
    display: block;
    height: 100%;
  }

  img + img {
    margin-left: 5px;
  }

  @media (min-width: 64em) {
    overflow-x: auto;
    margin: 0 auto;
    max-width: 1540px;
    height: auto;
    flex-wrap: wrap;

    img {
      flex: 1;
      display: block;
      width: 30%;
      // height: auto;
      margin: 5px;
    }
  }
`

const ScrollIndicator = styled.span`
  text-align: center;
  width: 100%;
  display: block;
  font-size: 0.8rem;
  position: absolute;
  bottom: 0.5rem;
  left: 0;
  color: #fff;

  @media (min-width: 64em) {
    display: none;
  }
`

export default () => (
  <div>
    <Main>
      <Section>
        <Title>Villanyszerelés</Title>
        <p>
          A villanyszerelési munkálatok az egyik legfontosabb része egy lakás felújításnak, egyszer kell ezeket a
          munkálatokat megcsinálni, de akkor jól! Utána szinte soha nem lesz vele problémánk, ha mindent kicseréltek,
          mindent jó helyre kötöttek be és minden a mi ízlésünk szerint van. Rengeteg panellakásban, de más lakásokban
          is alumínium vezetékek vannak. Több gond is van vele az első az, hogy nagyon törik. Nehéz hajlítani, ezért
          könnyen el tud törni. Ráadásul rengeteg lakásban védőcső nélkül építették bele a falban. Felújítás során réz
          vezetékekre cseréljük, ami sokkal biztonságosabb, ha már a vezetékeket kicseréljük, akkor érdemes a
          kapcsolótáblát is, melyben el tudjuk helyezni a Fi relét, azaz áram-védőkapcsolót, amely életet menthet, mivel
          azelőtt leolt, hogy halálos áramütést szenvednénk. Fontos dolog, hogy a villanyszerelés előtt tudjuk a lakás
          berendezések elhelyezkedését. Tudnunk kell előre, hogy hova fog kerülni a hűtő, a tűzhely, a televízió, a
          számítógép, stb. Ki kell találnunk, hogy hova fognak kerülni a konnektorok, a kapcsolók. Fontos, hogy
          megfelelő kapcsolókat, és konnektorokat válaszunk., minőségben, színben, formában, igényekhez igazítva.
          Figyelni kell továbbá a lámpákra, csillárokra. Az elvégzett munka után, mérési jegyzőkönyvet készítünk.
          Munkánkra garanciát adunk. A villanyszerelés komoly munka, ne bízza a véletlenre, hívjon minket, és segítünk
          önnek megvalósítani álmai otthonát.
        </p>
        <p>Vállalunk:</p>
        <ul>
          <li>Közintézmény, Társasház, Családi ház, Ipari létesítmények villanyszerelését.</li>
          <li>Villámhárító rendszerek kiépítését</li>
          <li>Mérés és mérési jegyzőkönyv készítését</li>
          <li>Karbantartást, felújítást</li>
          <li>Nehézáramú szerelést</li>
          <li>Mérőhely kialakítást, szerelést, oszlop állítást</li>
          <li>Gyengeáramú szerelést (riasztó, kamerarendszer)</li>
          <li>Mindent, ami villanyszerelés</li>
        </ul>
      </Section>
      <Ajanlatkeres />
    </Main>
  </div>
)
